var map = {
	"./adrift-in-the-harbor-2.webp": 5332,
	"./azure-excursion.webp": 2536,
	"./ballad-in-goblets-3.webp": 4390,
	"./born-of-ocean-swell-2.webp": 3081,
	"./decree-of-the-deeps.webp": 4552,
	"./drifting-luminescence-2.webp": 8867,
	"./drifting-luminescence.webp": 1567,
	"./everbloom-violet.webp": 1773,
	"./everything.webp": 6293,
	"./farewell-of-snezhnaya-2.webp": 6732,
	"./gentry-of-hermitage-3.webp": 5246,
	"./invitation-to-mundane-life-2.webp": 2627,
	"./moment-of-bloom-2.webp": 9984,
	"./moment-of-bloom-4.webp": 6620,
	"./moment-of-bloom.webp": 5812,
	"./onis-royale.webp": 3300,
	"./reign-of-serenity-2.webp": 2654,
	"./reign-of-serenity.webp": 1623,
	"./secretum-secretorum-2.webp": 8671,
	"./tapestry-of-golden-flames.webp": 9795,
	"./the-herons-court-2.webp": 4362,
	"./the-herons-court.webp": 8673,
	"./the-transcendent-one-returns.webp": 3556,
	"./wanderlust-invocation.webp": 3041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;